import { Users } from "lucide-react"

import { lazyPage } from "../lazy-page"
import { defineDashboardModule } from "../types"

export const clients = defineDashboardModule({
  id: "clients",
  nav: [{ group: "Business", title: "Clients", to: "/clients", icon: Users }],
  routes: [
    {
      path: "/clients",
      component: lazyPage(
        () => import("./routes/client-list"),
        "ClientListPage"
      ),
    },
    {
      path: "/clients/new",
      component: lazyPage(() => import("./routes/client-new"), "ClientNewPage"),
    },
    {
      path: "/clients/:id",
      component: lazyPage(
        () => import("./routes/client-detail"),
        "ClientDetailPage"
      ),
    },
  ],
})
